export default "/images/vendor/flag-icon-css/flags/4x3/bm.svg?e2aa572a02963b087e48158ff3de2fcc";